import { NgModule } from "@angular/core";
import { BrandStatisticsService } from "./brand-statistics.service";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../shared/shared.module";
import { Ng2PaginationModule } from "ng2-pagination";
import { ReactiveFormsModule } from "@angular/forms";
import { Ng2AutoCompleteModule } from "ng2-auto-complete";

@NgModule({
    imports: [CommonModule, SharedModule, Ng2PaginationModule, ReactiveFormsModule, Ng2AutoCompleteModule],
    declarations: [],
    providers: [BrandStatisticsService]
})
export class BrandStatisticsModule { }


// WEBPACK FOOTER //
// ./src/app/brand-statistics/brand-statistics.module.ts